import React from "react";
import { Provider } from "react-redux";
import { createRoot } from "react-dom/client";

import App from "App";
import { store } from "app/store";
import * as serviceWorker from "serviceWorker";

import "index.css";

const root = createRoot(document.getElementById("root"));

root.render(
  <Provider store={store}>
    <App />
  </Provider>
);
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
